export default function ({ page_name }) {
    return {
        onShow () {
            this.$sendCtmEvtLog(`${page_name}页面展示`)
        }
    }
}
